import Link from 'next/link';
import { ILink } from 'utils/interfaces/commonInterfacesAndTypes';
import classes from './LinksColumn.module.css';
import useTranslation from 'next-translate/useTranslation';

type Props = {
   heading: string;
   links: ILink[];
};

const LinksColumn = ({ links, heading }: Props) => {
   const { t } = useTranslation('common');
   return (
      <div className={classes.column}>
         <h3 className={classes.heading}>{heading}</h3>
         <ul>
            {links.map(({ href, text }) => (
               <li key={href}>
                  <Link href={href}>
                     <a>{t(text)}</a>
                  </Link>
               </li>
            ))}
         </ul>
      </div>
   );
};

export default LinksColumn;
